import { Link } from "react-router-dom";
import { getHotVideos } from "@/lib/videos";
import { formatDuration, videoPath } from "@/lib/videos";

const themeTags = [
  { label: "都市情感", icon: "ri-building-2-line", query: "都市情感" },
  { label: "夜戏", icon: "ri-moon-clear-line", query: "夜戏" },
  { label: "青春", icon: "ri-sun-line", query: "青春" },
  { label: "治愈", icon: "ri-heart-2-line", query: "治愈" },
  { label: "一镜到底", icon: "ri-focus-3-line", query: "一镜到底" },
  { label: "音乐", icon: "ri-music-2-line", query: "音乐" },
  { label: "海边", icon: "ri-water-flash-line", query: "海边" },
  { label: "悬疑", icon: "ri-question-mark", query: "悬疑" },
];

export default function ThemeStrip() {
  const spotlight = getHotVideos(4);

  return (
    <section className="px-4 md:px-8 lg:px-12">
      <div className="rounded-lg border border-background-200/70 bg-background-100 p-5 md:p-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="h-[2px] w-6 bg-accent-500" />
              <span className="text-[11px] tracking-[0.24em] text-accent-400 font-label uppercase">By Theme</span>
            </div>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-50">按主题快速浏览</h2>
            <p className="mt-1.5 text-xs text-foreground-500">
              打开任一标签，直达全站相关内容合集。
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="flex flex-wrap gap-2">
              {themeTags.map((tag) => (
                <Link
                  key={tag.label}
                  to={`/search?q=${encodeURIComponent(tag.query)}`}
                  className="flex items-center gap-1.5 h-8 px-3 rounded-full bg-secondary-800/70 border border-secondary-700/60 text-xs text-secondary-200 hover:bg-primary-500/15 hover:border-primary-500/50 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className={tag.icon} />
                  {tag.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="grid grid-cols-4 gap-2">
              {spotlight.map((video) => (
                <Link
                  key={video.id}
                  to={videoPath(video.id)}
                  className="group relative block rounded-md overflow-hidden aspect-[3/4] bg-background-300 cursor-pointer"
                  title={`${video.title} ${formatDuration(video.duration)}`}
                >
                  <img
                    src={video.cover}
                    alt={`${video.title} 主题精选`}
                    title={`${video.title} 高清封面`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                  <span className="absolute inset-0 bg-gradient-to-t from-background-950/80 to-transparent" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}